// GST on a cost sheet's transportation / customization / marketing amounts. The rates are whole
// percentages on the cost summary (transportationGST, customizationGST, marketingGST); a sheet
// without a cost summary has none, so its amounts are taken as 0% GST. Same formula as the cost
// sheet form (LineItemsTable) and the PDF (pdfGenerator): amount × (1 + rate / 100).

export const gstRate = (item, rateKey) => Number(item?.costSummary?.[rateKey]) || 0;

export const withGst = (amount, rate) => (Number(amount) || 0) * (1 + (Number(rate) || 0) / 100);
